import React from 'react'

import { Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'

import { FineGraduationProvider } from './context'
import AddUFIRValueTab from './components/AddUFIRValue'
import FineGraduationTab from './components/FineGraduation'
import SearchTab from './components/Search'

const FineGraduationComponent: React.FC = () => {
  const {
    tabs,
    selectedTab,
    handleChangeTab
  } = useTabs(['Pesquisar', 'Gradação de Multas', 'Valor UFIR'])

  return (
    <>
      <Tab value={selectedTab.position} handleChange={handleChangeTab} tabs={tabs} />
      {selectedTab.position === 0 && <SearchTab />}
      {selectedTab.position === 1 && <FineGraduationTab />}
      {selectedTab.position === 2 && <AddUFIRValueTab />}
    </>
  )
}

const FineGraduation: React.FC = () => {
  return (
    <TabsProvider>
      <FineGraduationProvider>
        <FineGraduationComponent />
      </FineGraduationProvider>
    </TabsProvider>
  )
}

export default FineGraduation
